import {GRID_COLUMN_COUNT} from '../../../util/panelbankGrid';

export const getColumnWidth = ({
  panelBankWidth,
  gridItemMarginX,
  gridContainerPaddingX,
}: {
  panelBankWidth: number;
  gridItemMarginX: number;
  gridContainerPaddingX: number;
}) => {
  return (
    (panelBankWidth -
      gridItemMarginX * (GRID_COLUMN_COUNT - 1) -
      gridContainerPaddingX * 2) /
    GRID_COLUMN_COUNT
  );
};

/**
 * Get nearest grid coordinates for the given pixel values
 */
export const convertToGridCoords = ({
  xPx,
  yPx,
  gridItemMargin,
  columnWidth,
  gridRowHeight,
}: {
  xPx: number;
  yPx: number;
  gridItemMargin: number[];
  columnWidth: number;
  gridRowHeight: number;
}) => {
  // The pixel coordinates passed into this function may be out of the grid's bounds,
  // so we have to ensure that neither dimension we return here is negative.
  // Currently, the coordinates passed in are shifted up by a few pixels to make dragging up easier,
  // but there may be other reasons why the coordinates passed here could be out of bounds.
  return {
    x: Math.max(
      Math.floor((xPx - gridItemMargin[0]) / (columnWidth + gridItemMargin[0])),
      0
    ),
    y: Math.max(
      Math.ceil(
        (yPx - gridItemMargin[1]) / (gridRowHeight + gridItemMargin[1])
      ),
      0
    ),
  };
};
